import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../common/skeleton';

/*
 * Style.
 */

const AccountDetailsHeaderSkeletonContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  padding: 20px 16px;
`;

const AccountDetailsAvatarSkeleton = styled(Skeleton)`
  border-radius: 50%;
  margin-right: 12px;
`;

const AccountDetailsHeaderDetailsContainerDiv = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  gap: 4px;
  justify-content: center;
`;

/*
 * Component.
 */

export const AccountDetailsHeaderSkeleton: FC = () => (
  <AccountDetailsHeaderSkeletonContainerDiv>
    <AccountDetailsAvatarSkeleton width="48px" height="48px" />
    <AccountDetailsHeaderDetailsContainerDiv>
      <Skeleton height="20px" />
    </AccountDetailsHeaderDetailsContainerDiv>
  </AccountDetailsHeaderSkeletonContainerDiv>
);
